export class Scrap {

    constructor(
        public id = null,
        public potext = null,
        public date = null,
        public category: Objet = new Objet(),
        public width = 0,
        public length = 0,
        public height = 0,
        public tareWeight = 0,
        public grossWeight = 0,
        public status = null,
        public dateClosed = null,
        public shippedDate = null,
        public internallocation_id = null,
        public internalLocation = '',
        public lastUpdated = null,
        public po_id = null,
        public item = '',
        public nameInternal = '',
        public reference = '',
        public invoice = ''
    ) {}
}

export class Objet {

    constructor(
        public id = null,
        public name = ''
    ) {}
}